import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import * as icons from '@creditornot/alchemy-react/icons';
import { TextButtonLink as BaseTextButtonLink } from '@creditornot/cb-button';
import { typographyCss } from '@creditornot/cb-ingredients';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { assortmentProductRedirectRouteApi } from 'features/assortment/routeApi';

import girl_gasp from '../images/girl_gasp.png';

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const TextButtonLink = styled(BaseTextButtonLink)`
  text-transform: lowercase;
`;

const Content = styled(Stack)`
  max-width: 490px;
  text-align: center;
`;

const Illustration = styled.img`
  width: 240px;
  height: 160px;
  margin-bottom: 8px;
`;

const Title = styled.div`
  ${typographyCss.headline}
`;

const Body = styled.div`
  ${typographyCss.body}
`;

type Props = {
  reset: () => void;
};

export const AssortmentRedirectError = ({ reset }: Props) => {
  const f = useFormatMessage();
  const { productCode, from } = assortmentProductRedirectRouteApi.useSearch();
  const navigate = useNavigate();

  const tryAgainLink = () => (
    <TextButtonLink onClick={reset}>{f('assortment.try_again')}</TextButtonLink>
  );

  return (
    <Root>
      <Content gap="regularXxxlarge" alignItems="center">
        <Illustration src={girl_gasp} alt="girl gasp illustration" />
        <Stack gap="regularMedium">
          <Title>{f('assortment.redirect_error_title')}</Title>
          <Body>
            <FormattedMessage
              id="assortment.redirect_error_description"
              values={{
                productCode,
                tryAgain: tryAgainLink(),
              }}
            />
          </Body>
        </Stack>

        {from && (
          <TextButtonLink
            size="small"
            icon={icons.arrowLeft}
            onClick={() => {
              return navigate({ to: from });
            }}
          >
            {f('assortment.go_back')}
          </TextButtonLink>
        )}
      </Content>
    </Root>
  );
};
